import {
  Family,
  IEconomicGroupGoalDetailPerMonth,
  IEconomicGroupGoalsDetails,
  PeriodGoalDetail
} from '@/modules/business-plan/modules/approval/pages/ford-goal-settings/types';
import {goalTypeEnum} from '@/modules/business-plan/modules/models/enums/goalTypeEnum';
import {SaleTypeEnum} from '@/modules/neodash/model/types/enums/saleTypeEnum';
import {SalesChannel} from '@/modules/direct-sales/enums';
import {TupleDictionary} from '@/utils/tupleDictionary';

export class EconomicGroupGoalDetailPerMonth implements IEconomicGroupGoalDetailPerMonth {
  constructor(month: number, saleChannel: SalesChannel, goalValue: number) {

    this.month = month;
    this.saleChannel = saleChannel;
    this.goalValue = goalValue;
  }

  month: number;
  saleChannel: SalesChannel;
  goalValue: number;
}

export class EconomigGroupGoalDetail implements IEconomicGroupGoalsDetails {
  constructor(goalDetail: IEconomicGroupGoalsDetails, family: Family, dictDistributions: TupleDictionary<[number, SalesChannel, number], number>) {
    this.businessPlan = goalDetail.businessPlan;
    this.continuity = goalDetail.continuity;
    this.goalTypeSelected = goalDetail.goalTypeSelected;
    this.goalValue = goalDetail.goalValue;
    this.idFamily = goalDetail.idFamily;
    this.family = family;
    this.idSaleType = goalDetail.idSaleType;
    this.industry = goalDetail.industry;
    this.customIndustry = goalDetail.customIndustry;
    this.justification = goalDetail.justification;
    this.justificationTotal = goalDetail.justificationTotal;
    this.isNegotiateConcluded = goalDetail.isNegotiateConcluded;
    this.nameSegment = goalDetail.nameSegment;
    this.potential = goalDetail.potential;
    this.responsibleName = goalDetail.responsibleName;
    this.sale = goalDetail.sale;
    this.goalPerMonths = goalDetail.goalPerMonths;

    if (!goalDetail.goalPerMonths || !goalDetail.goalPerMonths.length) {
      this.generateGoalPerMonthValues(family, dictDistributions)
    }
  }

  idFamily: number;
  family: Family;
  businessPlan: number;
  continuity: number;
  nameSegment: string;
  goalTypeSelected: goalTypeEnum;
  idSaleType: SaleTypeEnum;
  goalValue: number;
  goalValueTotal: number;
  justification: string;
  justificationTotal: string;
  isNegotiateConcluded: boolean;
  potential: number;
  responsibleName: string;
  showSaveButton: boolean;
  styleInput: string;
  isRadioSelected: boolean;
  industry: PeriodGoalDetail;
  customIndustry?: PeriodGoalDetail;
  sale: PeriodGoalDetail;
  inputValue: number;
  goalPerMonths: EconomicGroupGoalDetailPerMonth[];

  public setGoalValue(value: number) {
    this.goalValue = value;

    const dictionaryGoals = new TupleDictionary<[number], goalTypeEnum>()
    dictionaryGoals.set([this.businessPlan], goalTypeEnum.BusinessPlan);

    const selectedGoalType = dictionaryGoals.get([this.goalValue]);

    this.goalTypeSelected = selectedGoalType ? selectedGoalType : goalTypeEnum.Manual;
  }

  public generateGoalPerMonthValues(family: Family, dictDistributions: TupleDictionary<[number, SalesChannel, number], number>) {
    const months = new Array(12).fill(1).map((_, index) =>  1 + index);

    this.goalPerMonths = family.saleChannels
        .map(saleChannel => {
          return months.map(month => {
            const saleChannelEnum = saleChannel.value as SalesChannel;
            const value = Math.round(this.goalValue * dictDistributions.get([month, saleChannelEnum, this.idFamily]));

            return new EconomicGroupGoalDetailPerMonth(month, saleChannelEnum, value)
          })
        })
        .flat();
  }

  public getTtlGoalPerMonthBy(saleChannel: SalesChannel | undefined = undefined, month: number | undefined = undefined) : number {
    return this.goalPerMonths
        .filter(x => (x.saleChannel === saleChannel || !saleChannel) && (x.month === month || !month) && x.goalValue > 0)
        .sumBy(x => x.goalValue);
  }
}
